import React, { useState, useEffect, useRef } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import useAuth from "../utils/useAuth";
import { axiosWithoutHeader } from "../api/axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TextField, Button, Grid, CircularProgress, Box } from "@mui/material";
import { useFormik } from "formik";
import { MuiOtpInput } from "mui-one-time-password-input";
import InputLabel from "@mui/material/InputLabel";
import { Toast } from "primereact/toast";
import loader from "../utils/Helper";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";
import "./Login.css";

const OTP_URL = "/account/login";
const LOGIN_URL = "/account/verifyLoginPin";
const validateChar = (value, index) => {
  return /^\d$/.test(value);
};

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const initialValues = {
  username: "",
  otp: "",
};
const Login = () => {
  const toast = useRef(null);
  const userNameRef = useRef();
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [resendOtp, setresendOtp] = useState(false);
  const [countdown, setCountdown] = useState(0); // Countdown timer
  const [currentStep, setCurrentStep] = useState(1);
  const validate = (values) => {
    const errors = {};

    // username validation
    if (!values.username) {
      userNameRef.current.focus();
      errors.username = "Username is required ";
    }

    // OTP validation
    if (!values.otp && currentStep == 2 && !resendOtp) {
      errors.otp = "Opt is required";
    }

    return errors;
  };
  const handleFormSubmit = (values) => {
    if (currentStep == 1 || resendOtp) {
      const postData = {
        username: values.username,
      };
      handleOTP(postData);
    } else if (currentStep == 2 && !resendOtp) {
      const postData = {
        username: values.username,
        otp: values.otp,
      };
      handleLogin(postData);
    } else {
      return;
    }
  };

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      currentStep,
      resendOtp,
    },
    onSubmit: handleFormSubmit,
    validateOnBlur: true, // Disable onBlur validation
    validateOnChange: false, // Disable onChange validation
    validate: validate,
  });

  const handleLogin = async (postData) => {
    try {
      setLoading(true);
      loader.isLoading(true);
      const response = await axiosWithoutHeader.post(LOGIN_URL, postData);
      if (response.status === 200) {
        const {
          jwtToken,
          accountId: id,
          firstName,
          lastName,
          isAdmin,
          userId,
          email,
          jwtExpiryToken,
          isSuperAdmin,
          username,
          isProfileComplete,
        } = response.data;

        const userData = {
          id: userId,
          jwtToken,
          firstName,
          lastName,
          email,
          jwtExpiryToken,
          isAdmin,
          isSuperAdmin,
          accountId: id,
          username,
          isProfileComplete,
        };
        setAuth({ id, firstName, lastName, isAdmin, jwtToken });
        localStorage.setItem("jwtToken", userData.jwtToken);
        localStorage.setItem("user", JSON.stringify(userData));
        navigate(from, { replace: true });
      }
    } catch (err) {
      setOpen(true);
      setSeverity('error');
      setMessage(err.response.data.message);

    } finally {
      setLoading(false);
      loader.isLoading(false);
    }
  };
  const handleOTP = async (postData) => {
    setLoading(true);
    loader.isLoading(true);
    try {
      const response = await axiosWithoutHeader.post(OTP_URL, postData);
      if (response.status === 200) {
        setOpen(true);
        setSeverity('success');
        setMessage('OTP sent successfully');
        setCountdown(30);
        setCurrentStep(2);
      }
    } catch (err) {
      userNameRef.current.focus();
      setOpen(true);
      setSeverity('error');
      setMessage(err.response.data.error);
    } finally {
      setLoading(false);
      loader.isLoading(false);
      setresendOtp(false);
    }
  };

  useEffect(() => {
    let timer = null;

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, [countdown]);
  useEffect(() => {
    if (resendOtp) {
      formik.setFieldError("otp", "");

      formik.handleSubmit();
    }
  }, [resendOtp]);

  const handleClose = async () => {
    setOpen(false);
  };

  return (
    <div className="bg-color">
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={SlideTransition}
      >
        <Alert
          onClose={handleClose}
          severity= {severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <div class="page">
        <div class="brand">
          <img
            src="/newlogo.png"
            className="logoImage"
            alt="Logo"
          />
        </div>

        <section class="content">
          <div class="hero">
            <h1>
              Your Trusted Partner
              <br />
              in <span>Tax Solutions</span>
            </h1>

            <p>
              Our multidisciplinary team of experienced Chartered Accountants,
              Advocates, Lawyers and Company Secretaries provides comprehensive
              solutions.
            </p>

            <div class="features">
              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="10" cy="7" r="4" />
                  <path d="M20 8v6" />
                  <path d="M23 11h-6" />
                </svg>
                Expert Team
              </div>

              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <path d="M9 2v4" />
                  <path d="M15 2v4" />
                  <path d="M9 18v4" />
                  <path d="M15 18v4" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                Reliable Platform
              </div>

              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Secure Access
              </div>
            </div>

            <div class="illustration" aria-hidden="true">
              <img
                src="/illustration.png"
                width="475px"
                height="400px"
              />
            </div>
          </div>

          <div class="login-card">
            <h2>Welcome</h2>

            <p class="subtitle">
              One-stop platform for comprehensive tax solutions
            </p>

             <form onSubmit={formik.handleSubmit}>
              {currentStep === 1 && (
                  <div class="input-wrap">
                    <TextField
                        inputRef={userNameRef}
                        id="username"
                        name="username"
                        label="Username"
                        fullWidth
                        className="custom-inputField "
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.username &&
                          Boolean(formik.errors.username)
                        }
                        helperText={
                          formik.touched.username && formik.errors.username
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                  </div>
                )}

                 {currentStep === 2 && (
                  <Grid


                    marginTop={"15px"}
                    justifyContent={"center"}
                    display={'flex'}

                  >
                    <Grid item xs={12} >
                      <p className="text-align-center">
                        OTP has been sent to registered email id/phone number
                      </p>
                      <InputLabel htmlFor="otp-input">
                        Please enter OTP{" "}
                      </InputLabel>
                      <MuiOtpInput
                        length={6}

                        autoFocus
                        validateChar={validateChar}
                        value={formik.values.otp}
                        onChange={(value) =>
                          formik.setFieldValue("otp", value)
                        }

                        className="custom-otpfield"

                        InputLabelProps={{
                          id: "otp-input",
                          "aria-labelledby": "otp-input-label",
                        }}
                      />
                      {formik.touched.otp && formik.errors.otp ? (
                        <div style={{ alignItems: 'flex-start', marginBottom: '10px', marginTop: '10px', display: 'flex' }} className="text-danger">{formik.errors.otp}</div>
                      ) : null}

                      <div className="countdown-text">
                        <Box
                          display={"flex"}
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                        >
                          {countdown > 0 ? (
                            <p>
                              Resend OTP in : 00:
                              {countdown < 10 ? `0${countdown}` : countdown}
                            </p>
                          ) : (
                            <Button
                              variant="text"
                              onClick={() => {
                                setresendOtp(true);
                              }}
                              style={{
                                height: "14px",
                                textTransform: "capitalize",
                                font: "12px",
                              }}
                            >
                              {resendOtp ? (
                                <CircularProgress
                                  size={20}
                                  style={{ marginRight: "5px" }}
                                />
                              ) : (
                                "Resend OTP"
                              )}
                            </Button>
                          )}

                          <Button
                            variant="text"
                            style={{
                              height: "14px",
                              textTransform: "capitalize",
                              font: "12px",

                            }}
                            disabled={resendOtp}
                            onClick={() => {
                              formik.setFieldValue("otp", "");
                              setCountdown(0);
                              setCurrentStep(1);
                            }}
                          >
                            login with another account
                          </Button>
                        </Box>
                      </div>
                    </Grid>
                  </Grid>
                )}

              <button type="submit" class="otp-button">
                 {loading ? 
                 (
                    <CircularProgress
                      size={20}
                      style={{ marginRight: "5px" }}
                    />
                  ) : (
                    currentStep == 1 ? "GET OTP" : "Login"
                  )}
              </button>
            </form>
                
            {currentStep === 1 && <Link className="forgot" to="/forgot-username">Forgot username?</Link>}     

          </div>
        </section>

        <div class="floating-ball" aria-hidden="true">
          <img
            src="/ball.png"
            width="150px"
            height="150px"
          />
        </div>
        <div class="sparkle" aria-hidden="true"></div>

        <footer class="footer">
          <span>Don't have an account?</span>

          {currentStep === 1 && 
          <span>
            <Link to="/signup" style={{ marginRight: "10px" }}>
            Sign Up
            </Link>{" "}
          <span class="divider">|</span>
                <a href="https://clearrmynotice.com" style={{ marginLeft: "10px" }}>
            Homepage
            </a>
            </span>}
        </footer>
      </div>
    </div>
  );
};

export default Login;
